import {axiosGet, urlGenerator} from "../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        const getTranslate = (row, key) => {
            const locate = window?.appLanguage.toLowerCase()

            if (!row[key]) {
                return ''
            }

            if (row[key][locate] && row[key][locate] !== '') {
                return row[key][locate]
            }

            return row[key]['ja'] || ''
        }

        return {
            urlGenerator,
            options: {
                name             : this.$t('jobs'),
                url              : `${TENANT_BASE_URL}app/attribute`,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('icon'),
                        type     : 'custom-html',
                        key      : 'icon',
                        isVisible: true,
                        modifier : (value, row) => {
                            if (value) {
                                return '<i data-feather="' + value + '"/>';
                            }
                        }
                    },
                    {
                        title    : this.$t('name'),
                        type     : 'custom-html',
                        key      : 'name',
                        isVisible: true,
                        modifier : (value, row) => value
                    },
                    {
                        title    : this.$t('label'),
                        type     : 'custom-html',
                        key      : 'label',
                        isVisible: true,
                        modifier : (value, row) => getTranslate(row, 'label')
                    },
                    {
                        title    : this.$t('type'),
                        type     : 'custom-html',
                        key      : 'type',
                        isVisible: true,
                        modifier : (value, row) => value
                    },
                    {
                        title    : this.$t('entity_type'),
                        type     : 'custom-html',
                        key      : 'entity_type',
                        isVisible: true,
                        modifier : (value, row) => value
                    },
                    {
                        title    : this.$t('order'),
                        type     : 'custom-html',
                        key      : 'order',
                        isVisible: true,
                        modifier : (value, row) => value
                    },
                ],
                filters          : [],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'default',
                actions          : [
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_attribute')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/attribute`,
                        name     : 'delete',
                        modifier : row => this.$can('delete_attribute')
                    }
                ],
            }
        }
    },
}